export const [
  TOGGLE_SHOW_BOTTOM_BUTTONS,
  ADD_TO_DISAPROOVED_TEMP_LIST,
  REMOVE_FROM_DISAPROOVED_TEMP_LIST,
  ADD_TO_APROOVED_TEMP_LIST,
  REMOVE_FROM_APROOVED_TEMP_LIST,
  CLEAR_TEMP_LISTS,
  CLEAR_APROOVED_TEMP_LIST,
  CLEAR_DISAPROOVED_TEMP_LIST,
  TOGGLE_DELETE_MODAL,
  TOGGLE_SAVE_MODAL,
  TOGGLE_DISAPROOVED_REASON_MODAL,
  TOGGLE_DISAPROOVED_SET_MODAL,
  TOGGLE_APROOVED_SET_MODAL,
  SET_REASON_TO_DISAPROOVED_PHOTO,
  SET_ERROR_LIST,
  RESET_ERROR_LIST,
] = [
  'TOGGLE_SHOW_BOTTOM_BUTTONS',
  'ADD_TO_DISAPROOVED_TEMP_LIST',
  'REMOVE_FROM_DISAPROOVED_TEMP_LIST',
  'ADD_TO_APROOVED_TEMP_LIST',
  'REMOVE_FROM_APROOVED_TEMP_LIST',
  'CLEAR_TEMP_LISTS',
  'CLEAR_APROOVED_TEMP_LIST',
  'CLEAR_DISAPROOVED_TEMP_LIST',
  'TOGGLE_DELETE_MODAL',
  'TOGGLE_SAVE_MODAL',
  'TOGGLE_DISAPROOVED_REASON_MODAL',
  'TOGGLE_DISAPROOVED_SET_MODAL',
  'TOGGLE_APROOVED_SET_MODAL',
  'SET_REASON_TO_DISAPROOVED_PHOTO',
  'SET_ERROR_LIST',
  'RESET_ERROR_LIST',
];

export function localReducer(state, action) {
  switch (action.type) {
    case SET_ERROR_LIST:
      return { ...state, errorList: [...state.errorList, action.payload] };
    case RESET_ERROR_LIST:
      return { ...state, errorList: [] };
    case SET_REASON_TO_DISAPROOVED_PHOTO:
      let tempArray = [...state.tempAproovedPhoto];
      tempArray[action.payload.index].reason = action.payload.reason;
      return {
        ...state,
        tempDisaproovedPhoto: [...tempArray],
      };
    case TOGGLE_SHOW_BOTTOM_BUTTONS:
      return { ...state, unsavedPage: action.payload };
    case ADD_TO_DISAPROOVED_TEMP_LIST:
      return {
        ...state,
        tempDisaproovedPhoto: [...state.tempDisaproovedPhoto, action.payload],
      };
    case REMOVE_FROM_DISAPROOVED_TEMP_LIST:
      return {
        ...state,
        tempDisaproovedPhoto: state.tempDisaproovedPhoto.filter(
          (item) => item.id !== action.payload.id
        ),
      };
    case ADD_TO_APROOVED_TEMP_LIST:
      return {
        ...state,
        tempAproovedPhoto: [...state.tempAproovedPhoto, action.payload],
      };
    case REMOVE_FROM_APROOVED_TEMP_LIST:
      return {
        ...state,
        tempAproovedPhoto: state.tempAproovedPhoto.filter(
          (item) => item.id !== action.payload.id
        ),
      };
    case CLEAR_TEMP_LISTS:
      return { tempDisaproovedPhoto: [], tempAproovedPhoto: [] };
    case CLEAR_APROOVED_TEMP_LIST:
      return { ...state, tempAproovedPhoto: [] };
    case CLEAR_DISAPROOVED_TEMP_LIST:
      return { ...state, tempDisaproovedPhoto: [] };
    case TOGGLE_DELETE_MODAL:
    case TOGGLE_DISAPROOVED_REASON_MODAL:
    case TOGGLE_DISAPROOVED_SET_MODAL:
    case TOGGLE_APROOVED_SET_MODAL:
    case TOGGLE_SAVE_MODAL:
      return { ...state, showModal: action.payload };
    default:
      return state;
  }
}
